import React, { forwardRef, useEffect, useRef, Suspense, useMemo, useState } from "react";
import { Canvas, extend, useThree, useLoader, useFrame, } from '@react-three/fiber'
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader'
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
import { Center, Float, Text3D, GradientTexture, useTexture } from "@react-three/drei";
import { getRandomIntNumberWithSymbol, getRandomNumber, getRandomNumberWithSymbol } from "../../../../functions/GeneralHelper";
import { useStore } from "../../store";
extend({ TextGeometry, OrbitControls })


const ObjectFloating = forwardRef(({ children,  url, size, ...props }, ref) => {
    const texture = useTexture(url)
    const floatIntensity = useMemo(() => getRandomNumber(2, 6), [])
    const speed = useMemo(() => getRandomNumber(0.1, 4), [])
    const { setObjectSelected, objectSelected, isDragging } = useStore()
    const [position, setPosition] = useState()
    useEffect(()=>{
        setPosition([getRandomNumberWithSymbol(15,25),getRandomNumberWithSymbol(15,20),0])
    },[])
    return (
        <Float  floatIntensity={floatIntensity} speed={speed} rotationIntensity={2}
        >
            <mesh
            position={position} ref={ref} scale={[2.5,2.5,2.5]}
                onPointerOver={(event) => {
                    if (objectSelected.length ===0)
                        setObjectSelected([event.object])
                }}
                onPointerOut={(event) => {
                    if (!isDragging)
                        setObjectSelected([])
                }}
            >
                <planeBufferGeometry args={size} />
                <meshBasicMaterial map={texture} opacity={1} transparent />
            </mesh>
        </Float>

    )
})

export default ObjectFloating